<template>
  <div class="container-fluid">
    <!-- 狀態列 -->
    <StatusBar :params="this.$route.query.params" />

    <!-- 查詢 -->
    <SearchBar
      :show="showSearchBar"
      @showSearchBar="showSearchBar = !showSearchBar"
      @search="(currentPage = 1), getResume()"
    >
      <template v-slot:searchItem>
        <!-- 關鍵字 -->
        <el-input
          class="w-100 item-bottom"
          clearable
          placeholder="關鍵字（姓名、Email、連絡電話）"
          v-model.trim="searchCondition.Keyword"
        />
        <!-- 學校名稱 -->
        <el-input
          class="w-100 item-bottom"
          clearable
          placeholder="學校名稱"
          v-model.trim="searchCondition.SchoolKeyWord"
        />
        <!-- 科系類別 -->
        <el-select
          class="w-100 item-bottom"
          multiple
          collapse-tags
          clearable
          placeholder="科系類別"
          v-model="searchCondition.Majors"
        >
          <el-option
            v-for="major in majorOptions"
            :key="major.Guid"
            :label="major.Name"
            :value="major.Name"
          >
          </el-option>
        </el-select>
        <!-- 科系名稱 -->
        <el-input
          class="w-100 item-bottom"
          clearable
          placeholder="科系名稱"
          v-model.trim="searchCondition.MajorNameKeyword"
        />
        <!-- 學歷等級 -->
        <el-select
          class="w-100 item-bottom"
          multiple
          collapse-tags
          clearable
          placeholder="學歷等級"
          v-model="searchCondition.EducationDegrees"
        >
          <el-option
            v-for="educationDegree in educationDegreeOptions"
            :key="educationDegree.Guid"
            :label="educationDegree.Name"
            :value="educationDegree.Name"
          >
          </el-option>
        </el-select>
        <!-- 外籍在台 -->
        <el-select
          class="w-100 item-bottom"
          clearable
          placeholder="外籍在台"
          v-model="searchCondition.Foreigner"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <!-- 領有身心障礙手冊 -->
        <el-select
          class="w-100 item-bottom"
          clearable
          placeholder="領有身心障礙手冊"
          v-model="searchCondition.HasDisabilityCard"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <!-- 通訊地區 -->
        <el-select
          class="w-100 item-bottom"
          multiple
          collapse-tags
          clearable
          placeholder="通訊地區"
          v-model="searchCondition.ContactDistricts"
        >
          <el-option
            v-for="district in districtOptions"
            :key="district.Guid"
            :label="district.Name"
            :value="district.Name"
          >
          </el-option>
        </el-select>
        <!-- 戶籍地區 -->
        <el-select
          class="w-100 item-bottom"
          multiple
          collapse-tags
          clearable
          placeholder="戶籍地區"
          v-model="searchCondition.Districts"
        >
          <el-option
            v-for="district in districtOptions"
            :key="district.Guid"
            :label="district.Name"
            :value="district.Name"
          >
          </el-option>
        </el-select>
        <!-- 履歷來源 -->
        <el-select
          class="w-100 item-bottom"
          multiple
          collapse-tags
          clearable
          placeholder="履歷來源"
          v-model="searchCondition.MatchSource"
        >
          <el-option label="首頁主動應徵" value="首頁主動應徵"></el-option>
          <el-option label="ERecruiter" value="ERecruiter"></el-option>
          <el-option label="臨時到廠轉入" value="臨時到廠轉入"></el-option>
          <el-option label="人才庫轉入" value="人才庫轉入"></el-option>
          <el-option label="轉推薦轉入" value="轉推薦轉入"></el-option>
          <el-option label="後台1111匯入" value="後台1111匯入"></el-option>
        </el-select>
        <!-- 履歷轉入日期 -->
        <el-date-picker
          class="w-100 item-bottom"
          type="daterange"
          clearable
          range-separator="-"
          start-placeholder="履歷轉入日期(起)"
          end-placeholder="履歷轉入日期(迄)"
          v-model="matchDateRange"
        />
        <!-- 應聘者狀態 -->
        <el-select
          class="w-100 item-bottom"
          multiple
          clearable
          collapse-tags
          placeholder="應聘者狀態"
          v-model="searchCondition.Status"
        >
          <el-option
            v-for="status in candidateStatusOptions"
            :key="status.key"
            :label="status.value"
            :value="status.key"
          >
          </el-option>
        </el-select>
        <!-- 履歷狀態 -->
        <el-select
          class="w-100 item-bottom"
          clearable
          placeholder="履歷狀態"
          v-model="searchCondition.IsExpire"
        >
          <el-option label="已過期" :value="true" />
          <el-option label="未過期" :value="false" />
        </el-select>
        <!-- 聯繫狀態 -->
        <el-cascader
          class="w-100"
          clearable
          :options="contactOptions"
          :props="{ multiple: true }"
          :show-all-levels="true"
          placeholder="聯繫狀態"
          v-model="searchCondition.ContactStatusGuids"
        />
      </template>
    </SearchBar>

    <div class="tool-list">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <!-- 匯入資料 -->
      <button
        type="button"
        class="btn btn-outline-info btn-sm tool-list-item"
        @click="openCommonModal({ event: 'upload' })"
      >
        匯入資料
      </button>
      <!-- 卡片顯示樣式 -->
      <CardStyle v-if="personList.length > 0" @changeStyle="changeStyle" />
    </div>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard
          ref="personCard"
          :showCheckbox="true"
          :person="person"
          @updatePersonList="updatePersonList"
        >
          <template v-slot:note="{ props }">
            <button type="button" @click="clickResumeNote(props)">
              <eva-icon name="color-picker-outline" fill="#000" />
            </button>
          </template>
          <template v-slot:tag="{ props }">
            <div class="result">{{ props.InterviewResult }}</div>
          </template>
          <!-- 內容 -->
          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>轉入職缺時間</th>
                <td>
                  {{ $common.dateTimeFormatter(props.JobMatchCreateTime) }}
                </td>
              </tr>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>學歷</th>
                <pre>
                  {{ props.Education ? props.Education[0] : null }}
                </pre>
              </tr>
              <tr>
                <th></th>
                <pre>
                  {{ props.Education ? props.Education[1] : null }}
                </pre>
              </tr>
              <tr>
                <th>經歷</th>
                <td>
                  {{ props.WorkExperience ? props.WorkExperience[0] : null }}
                </td>
              </tr>
              <tr>
                <th></th>
                <td>
                  {{ props.WorkExperience ? props.WorkExperience[1] : null }}
                </td>
              </tr>
              <tr>
                <th>履歷來源</th>
                <td>{{ props.Source }}</td>
              </tr>
              <tr>
                <th>最後聯繫</th>
                <pre>
                  {{ props.LatestContactRecord }}
                </pre>
              </tr>
              <tr>
                <th>最新應徵職缺</th>
                <pre>
                  {{ props.LatestJobApply }}／{{ props.LatestStatus }}
                </pre>
              </tr>
            </table>
          </template>
          <!-- button group -->
          <template v-slot:buttonGroup="{ props }">
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                檢視資訊<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetailModal(props)">
                  檢視履歷
                </el-dropdown-item>
                <el-dropdown-item @click.native="showProgressRecord(props)">
                  檢視歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button
              v-if="
                props.InterviewResult === '尚未邀約' ||
                props.InterviewResult === '複試'
              "
              type="button"
              @click.prevent="clickInterviewInvitation(props)"
            >
              面談邀約
            </button>
            <button type="button" @click="clickContactInfo(props)">
              聯繫資訊
            </button>
            <button
              v-if="
                props.ResumeType === 'DL' &&
                props.InterviewResult === '尚未邀約' &&
                $Permission.JobOpening.SpecialProcess.IsValid
              "
              @click="createAppointmentForm(props)"
            >
              起任用單
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 履歷 Note -->
    <ResumeNoteModal :personData="interviewee" @getFactory="getFactory" />

    <!-- 履歷分類  -->
    <ResumeTagModal :ResumeId="ResumeId" />

    <!-- 功能列 -->
    <ActionBar
      :show="showActionBar"
      :totalPerson="totalPerson"
      :selectedCardList="choosePersonList"
      @showActionBar="showActionBar = !showActionBar"
      @selectAllCards="selectAllCards"
      @clearSelectCard="clearSelectCard"
    >
      <template v-slot:button>
        <button
          type="button"
          class="action-btn"
          @click="openCommonModal({ event: 'expire' })"
        >
          <eva-icon name="clock-outline" fill="#FFF" />
          <span>標記為過期</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click="openCommonModal({ event: 'recover' })"
        >
          <eva-icon name="undo-outline" fill="#FFF" />
          <span>移除過期標記</span>
        </button>
        <button
          type="button"
          class="action-btn"
          style="background: red"
          @click="openCommonModal({ event: 'remove' })"
        >
          <eva-icon name="trash-2-outline" fill="#FFF" />
          <span>履歷移除</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click="openCommonModal({ event: 'factory' })"
        >
          <eva-icon name="settings-outline" fill="#FFF" />
          <span>維護廠別</span>
        </button>
        <a
          type="button"
          class="select-all-btn"
          style="margin-right: 5px; color: #000"
          href="javascript:void(0)"
          @click.prevent="selectSearchResult"
        >
          查詢結果全選
        </a>
      </template>
    </ActionBar>

    <!-- 面談邀約 -->
    <InterviewMailModal
      :personData="interviewee"
      @updatePerson="updatePerson"
    />

    <!-- 查詢結果全選 -->
    <SearchResultAll
      :totalPerson="totalPerson"
      @closeActionBar="showActionBar = false"
      @clearSelectCard="clearSelectCard"
      @getResume="getResume"
    />

    <!-- 聯絡資訊  -->
    <ContactInfoModal :personData="interviewee" />

    <!-- 匯入資料 API 回應訊息 -->
    <ResponseDataModal
      :successfulList="successMessage"
      :failedList="failMessage"
    />

    <!-- common Modal -->
    <div
      class="modal fade"
      id="commonModal"
      data-focus="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="common"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <h5 class="modal-title">{{ modalTitle }}</h5>
              <button
                v-if="modalEvent === 'upload'"
                type="button"
                class="close"
                data-dismiss="modal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              class="modal-body"
              :style="modalEvent === 'factory' ? { height: '330px' } : null"
            >
              <!-- 匯入資料 -->
              <div v-if="modalEvent === 'upload'">
                <p class="form-group">
                  <u
                    style="color: midnightblue; cursor: pointer"
                    @click.prevent="$common.downloadResumeTemplate"
                  >
                    點擊下載範例檔
                  </u>
                </p>
                <p class="form-group">
                  <span class="mark">* 檔案限制：[檔名].xlsx、[檔名].xls</span>
                  <br />
                  <span class="mark">* 大小限制：10MB 以下</span><br />
                  <span class="mark">* 上傳前請確認是否符合格式</span><br />
                </p>
                <div class="from-group">
                  <label for=""><span class="mark">*</span>檔案</label>
                  <el-upload
                    ref="upload"
                    action
                    accept=".xls,.xlsx"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="uploadFile"
                    :limit="1"
                  >
                    <el-button size="small" type="primary">點擊上傳</el-button>
                  </el-upload>
                </div>
              </div>
              <!-- 標期過期 -->
              <p v-else-if="modalEvent === 'expire'">確定將履歷標記為過期？</p>
              <!-- 移除過期標記 -->
              <p v-else-if="modalEvent === 'recover'">確定移除履歷過期標記？</p>
              <!-- 移除 -->
              <p v-else-if="modalEvent === 'remove'">確定將履歷移除？</p>
              <!-- 廠別 -->
              <div v-else>
                <ValidationProvider
                  name="廠別"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <multiselect
                    :options="factoryOptions"
                    multiple
                    placeholder="請選擇"
                    label="Name"
                    track-by="Guid"
                    v-model="chooseFactoryList"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div v-show="modalEvent !== 'upload'" class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                取消
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveModal)"
              >
                確認
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 檢視資訊 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                履歷
              </span>
            </a>
            <a
              v-if="showInterviewRecord"
              @click.prevent="detailCurrentPage = 1"
            >
              <span>
                <eva-icon name="message-circle-outline" fill="#FFF" />
                面談紀錄
              </span>
            </a>
            <a
              v-if="showAppointmentRecord"
              @click.prevent="detailCurrentPage = 2"
            >
              <span>
                <eva-icon name="clipboard-outline" fill="#FFF" />
                任用單
              </span>
            </a>
            <div
              class="close-show-detail"
              @click="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        style="margin-right: 10px"
                        @click="$store.commit('OpenResumeCategoryModal', true)"
                      >
                        分類
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 1" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">面談紀錄</div>
                    <div class="item"></div>
                  </div>
                  <InterviewRecord :MatchId="MatchId"></InterviewRecord>
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 2" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">任用單</div>
                    <div class="item"></div>
                  </div>
                  <AppointmentRecord :MatchId="MatchId"></AppointmentRecord>
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <!-- 檢視歷程 -->
    <ProgressRecordModal :Name="Name" :UserId="UserId" :Email="Email" />
  </div>
</template>

<script>
/* global $ */
import { mapActions, mapGetters } from "vuex";
// 招募狀態列表
import StatusBar from "@/components/back/OpeningManage/StatusBar";
// 公司LOGO
import Logo from "@/components/company/Logo.vue";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 功能列
import ActionBar from "@/components/back/ToolBar/ActionBar";
// 查詢列
import SearchBar from "@/components/back/ToolBar/SearchBar";
// 面談邀約
import InterviewMailModal from "@/components/back/Modal/InterviewMail";
// 履歷 Note
import ResumeNoteModal from "@/components/back/Modal/ResumeNote";
// 履歷分類
import ResumeTagModal from "@/components/back/Modal/ResumeTag";
// 查詢結果全選
import SearchResultAll from "@/components/back/Modal/SearchResultAll";
// 聯繫資訊
import ContactInfoModal from "@/components/back/Modal/ContactInfo";
// API 回應訊息
import ResponseDataModal from "@/components/back/Modal/ResponseData";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談紀錄
import InterviewRecord from "@/components/back/CandidateData/InterviewRecord";
// 任用單
import AppointmentRecord from "@/components/back/CandidateData/AppointmentRecord";
// 歷程
import ProgressRecordModal from "@/views/back/TalentQuery/ResultPage/Modal/ProgressRecord";

export default {
  name: "ResumeList",

  props: {
    did: { // 需求單號
      type: String,
    },
    kind: { // 履歷類型
      type: String,
    },
  },

  components: {
    StatusBar,
    Logo,
    PersonCard,
    CardStyle,
    SearchBar,
    ActionBar,
    InterviewMailModal,
    ResumeNoteModal,
    ResumeTagModal,
    SearchResultAll,
    ContactInfoModal,
    IdlResume,
    DlResume,
    InterviewRecord,
    ResponseDataModal,
    AppointmentRecord,
    ProgressRecordModal,
  },
  data() {
    return {
      // tab
      activeName: 0,

      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // modal 事件 (匯入資料、標記過期、移除過期標記、移除履歷、維護廠別)
      modalEvent: "",
      modalTitle: "",

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類
      showInterviewRecord: false, // 面談紀錄

      // 面談邀約
      interviewee: {},

      // 功能列
      showActionBar: false, // 預設不顯示
      choosePersonList: [], // 選取之人員列表

      // 匯入資料-回應訊息
      successMessage: [], // 成功訊息
      failMessage: [], // 失敗訊息

      // 查詢列
      showSearchBar: false,
      // 查詢條件
      searchCondition: {
        IsExpire: false,
        ContactStatusGuids: null,
      },
      matchDateRange: [],

      // 應聘者狀態
      candidateStatusOptions: [
        { key: "尚未邀約", value: "尚未邀約" },
        { key: "面談未到", value: "面談未到" },
        { key: "待面談", value: "待面談" },
        { key: "尚未完成面談紀錄與評估", value: "尚未完成面談紀錄與評估" },
        { key: "錄取", value: "錄取" },
        { key: "考慮中", value: "考慮中" },
        { key: "複試", value: "複試" },
        { key: "不錄取", value: "不錄取" },
        { key: "已完成任用", value: "已完成任用" },
        { key: "任用否決", value: "任用否決" },
      ],

      // 聯繫狀態
      contactOptions: [],

      // 廠別
      factoryOptions: [],
      chooseFactoryList: [],

      // 人員卡面列表
      personList: [],

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁

      // 檢視歷程
      Name: null,
      UserId: null,
      Email: null,
    };
  },

  methods: {
    // 取得 履歷數量
    getResume() {
      this.choosePersonList = [];
      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      let candidateStatus;
      candidateStatus =
        this.searchCondition.Status &&
        Object.keys(this.searchCondition.Status).length > 0
          ? String(this.searchCondition.Status)
          : null;

      const params = {
        ...this.searchCondition,
        Status: candidateStatus,
        ContactStatusGuids: this.searchCondition.ContactStatusGuids
          ? this.searchCondition.ContactStatusGuids.map((item) => {
              return item[1];
            })
          : null,
        MatchStart: this.matchDateRange ? this.matchDateRange[0] : null,
        MatchEnd: this.matchDateRange ? this.matchDateRange[1] : null,
        Page: this.currentPage,
        PerPage: 9,
      };

      localStorage.setItem("PARAMS", JSON.stringify(params));

      this.$api.jobManagement
        .getResumeViewPaging(params, this.did)
        .then((response) => {
          if (response.status === 200) {
            this.totalPerson = response.data.Quantity;
            this.personList = response.data.Datas;
            this.$store.commit("ScrollTop", false);
          }
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getResume();
    },

    // 更新卡片
    updatePerson() {
      this.currentPage = 1;
      this.getResume();
      this.$store.dispatch("GetJobManagementCount");
    },

    // 上傳檔案 API (匯入資料)
    uploadFile(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$notify({
          title: "失敗",
          message: "檔案大小不得超過10MB",
          type: "error",
          duration: 3500,
        });
        return false;
      }

      const api = `${window.endpoints.api}/ResumeModule/UploadResumeImport`;

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("UserId", this.$cookies.get("userId"));
      fd.append("ResumeType", this.kind);
      fd.append("ManpowerDemandNo", this.did);

      $("#commonModal").modal("hide");
      this.updateLoading(true);

      this.$http.post(api, fd).then((response) => {
        this.updateLoading(false);
        this.successMessage = response.data.filter((item) => {
          return item.indexOf("成功") !== -1;
        });
        this.failMessage = response.data.filter((item) => {
          return item.indexOf("失敗") !== -1;
        });
        this.$store.commit("OpenResponseDataModal", true);
        this.$refs.upload.clearFiles();
      });
    },

    // 履歷 Note
    clickResumeNote(person) {
      this.interviewee = person;
      this.$store.dispatch("getResumeSummary", person.MatchId);
      this.$store.commit("OpenResumeNoteModal", true);
    },

    // 儲存 Modal
    saveModal() {
      $("#commonModal").modal("hide");
      const choosePerson = this.choosePersonList.map(
        (person) => person.MatchId
      );
      switch (this.modalEvent) {
        case "expire": // 標記過期
          this.updateLoading(true);
          this.$api.jobManagement
            .expireResume({
              ManpowerDemandNo: this.did,
              MatchIds: choosePerson,
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: "已標記為過期",
                  type: "success",
                  duration: 2000,
                });
                this.getResume();
              }
              this.updateLoading(false);
            });
          break;
        case "recover": // 移除過期標記
          this.updateLoading(true);
          this.$api.jobManagement
            .recoverResume({
              ManpowerDemandNo: this.did,
              MatchIds: choosePerson,
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: "已移除過期標記",
                  type: "success",
                  duration: 2000,
                });
                this.getResume();
              }
              this.updateLoading(false);
            });
          break;
        case "remove": // 移除履歷
          this.updateLoading(true);
          this.$api.jobManagement
            .removeResume({
              ManpowerDemandNo: this.did,
              MatchIds: choosePerson,
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: "移除成功",
                  type: "success",
                  duration: 2000,
                });
                this.$router.push("/refresh");
              }
              this.updateLoading(false);
            });
          break;
        case "factory": // 維護廠別
          this.updateLoading(true);
          this.$api.jobManagement
            .changeFactoryTypes({
              MatchIds: this.choosePersonList.map((item) => item.MatchId),
              FactoryTypeGuids: this.chooseFactoryList.map((item) => item.Guid),
            })
            .then((response) => {
              if (response.status === 200) {
                this.clearSelectCard();
                this.$notify({
                  title: "成功",
                  message: "加入廠別成功",
                  type: "success",
                  duration: 2000,
                });
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 開啟 Modal
    openCommonModal({ event }) {
      switch (event) {
        case "upload":
          this.modalTitle = "匯入資料";
          this.modalEvent = "upload";
          break;
        case "expire":
          this.modalTitle = "標記過期";
          this.modalEvent = "expire";
          break;
        case "recover":
          this.modalTitle = "移除過期標記";
          this.modalEvent = "recover";
          break;
        case "remove":
          this.modalTitle = "移除履歷";
          this.modalEvent = "remove";
          break;
        case "factory":
          this.modalTitle = "維護廠別";
          this.modalEvent = "factory";
          this.chooseFactoryList = [];
          break;
      }
      this.$refs.common.reset();
      $("#commonModal").modal("show");
    },

    // 面談邀約
    clickInterviewInvitation(person) {
      this.interviewee = person;
      this.$store.commit("OpenInterviewMailModal", true);
    },

    // 聯繫資訊
    clickContactInfo(person) {
      this.interviewee = person;
      this.$store.commit("OpenContactInfoModal", true);
    },

    // 建立任用單
    createAppointmentForm(item) {
      this.$router.push({
        path: `/manager/form/evaluation/special/${item.MatchId}`,
      });
    },

    // 檢視資訊 Modal
    showDetailModal(person) {
      this.MatchId = person.MatchId;
      this.ResumeId = person.ResumeId;
      this.ResumeType = person.ResumeType;
      const interviewResult = [
        "錄取",
        "考慮中",
        "複試",
        "不錄取",
        "已完成任用",
        "任用否決",
      ];
      this.showInterviewRecord = interviewResult.includes(
        person.InterviewResult
      );
      const appointmentResult = ["已完成任用", "任用否決"];
      this.showAppointmentRecord = appointmentResult.includes(
        person.InterviewResult
      );
      this.isShowDetail = true;
    },

    // 檢視歷程
    showProgressRecord(person) {
      this.MatchId = person.Id;
      this.Name = person.Name;
      this.UserId = person.UserId;
      this.Email = person.Email;
      this.$store.commit("OpenCandidateProcessModal", true);
    },

    // 即時更新選取人員之列表
    updatePersonList(choosePerson) {
      let repeatIndex = this.choosePersonList.findIndex(
        (element) => element.MatchId === choosePerson[0].MatchId
      );
      if (repeatIndex === -1) {
        this.choosePersonList.push(choosePerson[0]);
      } else {
        this.choosePersonList.splice(repeatIndex, 1);
      }
    },

    // 查詢結果全選
    selectSearchResult() {
      this.selectAllCards();
      this.$store.commit("OpenSearchResultModal", true);
    },

    // 全選人員
    selectAllCards() {
      this.personList.forEach((item) => {
        if (!item.isChecked) {
          item.isChecked = true;
        }
      });
      this.choosePersonList = this.personList.filter(
        (item) => item.isChecked === true
      );
    },

    // 清除所選取人員
    clearSelectCard() {
      this.personList.forEach((item) => {
        item.isChecked = false;
      });
      this.choosePersonList = [];
    },

    // 取得 廠別
    getFactory(val) {
      this.factoryOptions = val.map((item) => {
        return {
          Guid: item.Guid,
          Name: item.Name,
        };
      });
    },

    async getData() {
      try {
        // 取得 聯繫狀態
        const status = await this.$api.contactRecord.getContactStatus(false);
        // 取得 科系類別
        await this.$store.dispatch("GetMajor");
        // 取得 學歷程度
        const educationDegree = await this.$api.education.getEducationDegree();
        this.educationDegreeOptions = educationDegree.data;
        // 取得 行政區
        const district = await this.$api.address.getDistrictFullName();
        this.districtOptions = district.data;

        this.contactOptions = status.data.map((item) => {
          return {
            value: item.Guid,
            label: item.Name,
            children: item.Children.map((children) => {
              return {
                value: children.Guid,
                label: children.Name,
              };
            }),
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    ...mapGetters(["majorOptions"]),
  },

  watch: {
    // 選取人員列表
    choosePersonList: function (e) {
      if (e.length > 0) {
        this.showActionBar = true;
        this.showSearchBar = false;
      } else {
        this.showActionBar = false;
      }
    },
    // 檢視資訊
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  created() {
    this.getResume();
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
pre {
  margin: 0px 0px;
  padding: 3px 10px;
  font-size: 0.95rem;
  word-break: break-all;
  white-space: pre-line;
  height: 62px;
}
#commonModal {
  .modal-header {
    .close {
      margin: -3rem -1rem -1rem auto;
    }
  }
  .modal-body {
    max-height: unset;
    overflow: unset;
  }
}

/deep/ .el-input {
  display: block;
}

/deep/ .el-select {
  display: block;
}
</style>
